import classNames from 'classnames'
import * as React from 'react'

import {isEmptyRichtext, makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Iframe from '@/components/Iframe'
import Images from '@/components/Images'
import Kicker from '@/components/Kicker'

const ContentCenter = ({
  backgroundColors,
  id,
  headingTag,
  kicker,
  heading,
  content,
  buttons,
  backgroundText,
  images,
  iframe,
  _editable,
}) => {
  const HeadingTag = headingTag || 'p'

  return (
    <section
      id={id ? id : undefined}
      {...makeEditable(_editable)}
      className={classNames('overflow-hidden py-12', backgroundColors.current)}
    >
      <Grid className='gap-y-8 text-center'>
        <HeadingTag className='relative col-span-full mx-auto mb-8 w-fit md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3'>
          <Kicker
            kicker={kicker}
            theme='sticker'
            className='absolute left-0 top-0 z-10 -translate-x-1/2 -translate-y-2/3 -rotate-[10deg]'
          />
          <Heading heading={heading} className='block' />
        </HeadingTag>

        {!isEmptyRichtext(content) && (
          <div className='relative col-span-full mx-auto md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3'>
            <Doodle />
            <Content content={content} size='l-medium' />
          </div>
        )}

        {images && images.length > 0 && (
          <div className='relative col-span-full md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4'>
            <p className='misc-scrolling-title absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 whitespace-nowrap text-[transparent] [-webkit-text-stroke:theme(colors.purple.900)_1px] md:block'>
              {backgroundText}
            </p>
            <Images
              className='aspect-h-1 aspect-w-1'
              images={images}
              imageProps={{fitIn: true, ratio: '1:1'}}
            />
          </div>
        )}

        {buttons && buttons.length > 0 && (
          <div className='col-span-full'>
            <Buttons buttons={buttons} className='flex items-center justify-center gap-4' />
          </div>
        )}

        {iframe && (
          <div className='col-span-full'>
            <Iframe iframe={iframe} />
          </div>
        )}
      </Grid>
    </section>
  )
}

const Doodle = () => {
  return (
    <svg
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 110 125'
      className='absolute right-full top-1/2 hidden w-30 -translate-y-2/3 translate-x-8 md:block'
    >
      <g clipPath='url(#content-center-doodle)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.49 42.48a.57.57 0 0 0 .23.78l22.35 11.92a.57.57 0 0 0 .54-1L18.26 42.24a.57.57 0 0 0-.77.23ZM-1.85 83.95c-.1.3.08.62.38.71.9.28 2.42.36 4.22.34 1.83-.03 4.02-.16 6.3-.35 4.55-.39 9.5-1 12.66-1.46a.57.57 0 1 0-.17-1.13c-3.14.45-8.06 1.07-12.6 1.45-2.26.19-4.42.32-6.2.34a15.1 15.1 0 0 1-3.88-.28.57.57 0 0 0-.71.38Zm32.81 17.26a.57.57 0 1 1 .8.81L18.5 115.2a.57.57 0 1 1-.8-.82l13.27-13.16Zm51.4-97.79a.57.57 0 0 0-.26.77c.03.04.07.2.1.5.04.27.06.63.06 1.05 0 .85-.05 1.92-.13 3.06a119.2 119.2 0 0 1-.68 6.52.57.57 0 1 0 1.13.15c.22-1.68.52-4.27.69-6.59.08-1.15.14-2.25.13-3.14 0-.45-.02-.85-.06-1.19-.03-.31-.1-.64-.22-.88a.57.57 0 0 0-.76-.25ZM50.18 13.96a.57.57 0 1 1 1.07-.4l6.55 17.7a.57.57 0 0 1-1.07.4l-6.55-17.7Z'
          className='fill-violet-600'
        />
      </g>
      <defs>
        <clipPath id='content-center-doodle'>
          <path
            fill='#fff'
            transform='scale(1 -1) rotate(-45.24 -116.51 -11.55)'
            d='M0 0h54.23v137.76H0z'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ContentCenter
